<div class="toast-container">
  <div
    *ngFor="let notification of notifications"
    class="toast"
    [ngClass]="'toast-' + notification.type"
    [@animationNotification]>

    <div class="toast-icon">
      <svg *ngIf="notification.type === 'success'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
      <svg *ngIf="notification.type === 'error'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="15" y1="9" x2="9" y2="15"></line>
        <line x1="9" y1="9" x2="15" y2="15"></line>
      </svg>
      <svg *ngIf="notification.type === 'info'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
      <svg *ngIf="notification.type === 'warning'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
    </div>

    <div class="toast-content">
      <span class="toast-title">{{ notification.titre }}</span>
      <span class="toast-message">{{ notification.message }}</span>
    </div>

    <div class="toast-actions" *ngIf="notification.actions?.length">
      <button
        *ngFor="let a of notification.actions"
        type="button"
        class="toast-action-btn"
        [ngClass]="a.variante ? 'toast-action-' + a.variante : ''"
        (click)="action(notification.id, a.id)">
        {{ a.libelle }}
      </button>
    </div>

    <button class="toast-close" (click)="retirerNotification(notification.id)" aria-label="Fermer">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="toast-progress" [style.animation-duration]="notification.duree + 'ms'"></div>
  </div>
</div>
